export const SUBDOMAIN_IDS = {
    EVEROU:                 1,
    BUDGETS:                2,
    EVEROU_CLOCKINS_PRESET: 3,
    DEVELOPERS:             4,
    PMS:                    5,
    RENTAL:                 6,
};